import { ListFilter } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from '@/components/ui/select'

interface FilterButtonProps {
  label: string
  value?: string
  onValueChange?: (_value: string) => void
  options: Array<{ value: string; label: string }>
  className?: string
}

export function FilterButton({
  label,
  value,
  onValueChange,
  options,
  className = ''
}: FilterButtonProps) {
  const selectedOption = options.find(opt => opt.value === value)
  const displayText = selectedOption ? selectedOption.label : label

  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger className={`text-xs bg-white border-gray-200 flex gap-2 hover:bg-gray-50 w-full p-2 rounded-lg ${className}`}>
        <div className="flex items-center gap-3 flex-1">
          <ListFilter className="w-4 h-4 text-gray-900 flex-shrink-0" />
          <span className="text-gray-900">{displayText}</span>
        </div>
      </SelectTrigger>
      <SelectContent>
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
